import React from 'react';
import FaClose from 'react-icons/lib/fa/close';

export default class CookiePopUp extends React.Component {

    redirect = () => {
        this.props.history.push('/CookiePolicy');
    }

    render() {
        return (
            <div className="banner cookie-pop">
                <div className="container">
                    <div class="cookie">
                        <div className="row small mt-1">
                            <div className="col-xs-10 text-gray">
                                <h6 class="cookie__h-subline">Cookies on the nwm.realisedrate.com website</h6>
                            </div>
                            <div className="col-xs-2">
                                <div className="pull-right closeButton" onClick={this.props.hideCookiePopUp}>
                                    <FaClose />
                                </div>
                            </div>
                        </div>                      
                        <div>We use cookies and similar technologies to help provide you with the best possible online experience.
                            By using this site, you agree that we may store and access cookies and similar technologies on your device. 
                            You can <a className="cookiePoplink" onClick={this.redirect}>find out more including how to change your cookie settings here</a>.</div>
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/CookiePopUp.js